import styled from "styled-components";

const Header = styled.h1`
  font-family: "Spline Sans Mono", monospace;
  font-weight: bold;
  color: rgb(75, 0, 255);
`;

export { Header };
